import {ReactComponent as OndemandVideo} from "../icons/OnDemandVideo24.svg";

import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";

const VideoAlert = ({ url, text }) => {
  return (
    <Alert icon={<OndemandVideo sx={{color:"#ffffff"}} />} severity="info" sx={{backgroundColor:"#241773", color:"#ffffff", fontSize:"18px"}}>
      <Link sx={{color:"#ffffff", textDecorationColor:"#ffffff", cursor:"pointer"}} href={url} target="_blank" >
        VIDEO: {text}
      </Link>
    </Alert>
  );
};

export default VideoAlert;
